import React from 'react'
import SeweragePreventiveCard from './SeweragePreventive'
import { useNavigate } from 'react-router-dom'
import { Pie } from 'react-chartjs-2'
import { Pieoptions } from '../../../../../Helper/Data'


export default function SeweragePreventiveCardManage(props) {

    const { Countdata, HeaderMonthID, HeaderFinancialYear, MonthValue, YearValue, YearLabel, MonthLabel, WardValue, WardLabel, ProjectTypeId, DashboardName } = props

    const PreventiveWorkNavigate = (name, screenFlag) => {

        if (name === "Pumping Operation") {
            navigate(`/preventivepumping?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Security") {
            navigate(`/preventivesecurity?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "Energy Audit") {
            navigate(`/preventiveenergyaudit?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        } else if (name === "House Keeping") {
            navigate(`/preventivehousekeeping?name=${name}&Year=${YearValue}&YLable=${YearLabel}&Month=${MonthValue}&MLable=${MonthLabel}&WardName=${WardValue}&WLable=${WardLabel}&ProjectTypeId=${ProjectTypeId}&DashboardName=${DashboardName}`)
        }
    }
    const navigate = useNavigate()

    const PreventivePiedata = {
        labels: ["Pumping Operation", "Security", "Energy Audit", "House Keeping"],
        datasets: [
            {
                // label: '# of Votes',
                data: [
                    Countdata && Countdata?.PumpingOperationTotalCount,
                    Countdata && Countdata?.SecurityTotalCount,
                    Countdata && Countdata?.EnergyAuditTotalCount,
                    Countdata && Countdata?.HouseKeepingTotalCount,
                    // 20,30,60,40
                ],
                backgroundColor: [
                    "#3ecd72",
                    "#eeb259",
                    "#51dcd2",
                    "#ff8430",

                ],
                borderColor: [
                    // '#28c8c1',
                    // '#172b4d',
                    // '#993366',
                    // '#593e89',
                    // '#94408e',
                    // '#c74382',
                    // '#fa5d00',
                    // '#529ad2',
                    // '#ffc137',
                ],
                borderWidth: 1,
            },
        ],
    };

    return (
        <div className='row'>
            <div className="col-12 col-lg-8">
                <div className="row ps-lg-3">
                    <div className="col-12">
                        <h5 className="ps-2 py-2">Preventive Work</h5>
                    </div>
                    <div className="col-12 col-md-6 col-lg-6 mb-2">
                        <SeweragePreventiveCard
                            title="Pumping Operation"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/pump.png'
                            count={Countdata.PumpingOperationTotalCount ? Countdata.PumpingOperationTotalCount : '0'}
                            // navLink='/preventivepumping'
                            PreventiveWorkNavigate={PreventiveWorkNavigate}
                        />
                    </div>

                    <div className="col-12 col-md-6 col-lg-6 mb-2">
                        <SeweragePreventiveCard
                            title="Security"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/insurance.png'
                            count={Countdata.SecurityTotalCount ? Countdata.SecurityTotalCount : '0'}
                            // navLink='/preventivesecurity'
                            PreventiveWorkNavigate={PreventiveWorkNavigate}
                        />

                    </div>

                    <div className="col-12 col-md-6 col-lg-6 mb-2">
                        <SeweragePreventiveCard
                            title="Energy Audit"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/renewable-energy1.png'
                            count={Countdata.EnergyAuditTotalCount ? Countdata.EnergyAuditTotalCount : '0'}
                            // navLink='/preventiveenergyaudit'
                            PreventiveWorkNavigate={PreventiveWorkNavigate}
                        />

                    </div>

                    <div className="col-12 col-md-6 col-lg-6 mb-2">
                        <SeweragePreventiveCard
                            title="House Keeping"
                            cardName='py-2 wwork_img cursor'
                            imgPath='./assets/img/house-cleaning.png'
                            count={Countdata.HouseKeepingTotalCount ? Countdata.HouseKeepingTotalCount : '0'}
                            // navLink='/preventivehousekeeping'
                            PreventiveWorkNavigate={PreventiveWorkNavigate}
                        />

                    </div>

                </div>
            </div>
            <div className="col-12 col-lg-4 pt-lg-2">
                {/* <div className="row">
                    <div className="col-12">
                        <div className=" px-3 mt-3 pb-2 bg-white rounded rounded-3"> */}
                {
                    (Countdata?.PumpingOperationTotalCount != 0) || (Countdata?.SecurityTotalCount != 0) ||
                        (Countdata?.EnergyAuditTotalCount != 0) || (Countdata?.HouseKeepingTotalCount != 0) ?
                        <div className="row d-flex justify-content-center align-items-center">
                            <Pie
                                height={200}
                                // width={00}
                                options={Pieoptions}
                                data={PreventivePiedata}
                            />
                        </div>
                        :
                        <div className='text-danger text-center pt-lg-5 mt-lg-5 fw-bolder'>
                            No Data Found
                        </div>
                }
                {/* </div>
                    </div>
                </div> */}
            </div>
        </div>
    )

}

